export default __webpack_public_path__ + "static/media/leftLightAnchor.e16d82c3.svg";